/**
 * 系统管理 菜单管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>接口设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <el-select v-model="value" size="small" placeholder="请选择接口" ref="selectRef" @change="change(value)"
      class="user-search">
      <el-option v-for="item in formList" :key="item.id" :label="item.name" :value="item.value">
      </el-option>
    </el-select>
    <el-row>
      <!-- title -->
      <el-col :span="18">
        <el-form ref="form" :model="form" style="margin-top: 20px;">
          <el-form-item>
            <el-input type="textarea" placeholder="请输入内容" v-model="form.value" :autosize="{ minRows: 4, }">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="update">修改</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {

  getApiInfoList,

  updateApi
} from '../../api/userMG'
export default {
  data() {
    return {
      formList: [],
      form: {
        name: '',
        value: ''
      },
      name: '',
      value: ''
    }
  },
  /**
   * 创建完毕
   */

  created() {
    this.search()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    search() {
      getApiInfoList().then((res) => {
        this.formList = res.data
      })
    },
    change(value) {
      const selectedItem = this.formList.find(item => item.value === value);
      if (selectedItem) {
        this.form.name = selectedItem.name;
      }
      this.form.value = value;
    },
    update() {
      if (this.form.name == '') {
        return this.$message.error('请选择接口名称')
      }
      updateApi(this.form).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/Port.vue